<script lang="ts">
  import { navigate } from 'svelte-routing';
  export let isFrontPage = false;
</script>

<header
  id="header"
  class="header-normal"
  class:alt={isFrontPage}
>
  <div class="inner">
    <h1><a href="/" on:click|preventDefault={() => navigate('/')}>outlive the popes</a></h1>
    <p>An idle game that takes <b>104 years</b> to complete</p>
  </div>
</header>

<style>
  #header {
    background-color: #444;
    color: rgba(255, 255, 255, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    position: relative;
    cursor: default;
    background-image: url('/assets/images/vatican.webp');
    padding: 8em 0 6em 0;
    background-size: cover;
    background-position: center;
  }

  #header::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    background-image: url('/assets/images/overlay.png');
  }

  .inner {
    position: relative;
    z-index: 1;
    text-shadow: 1px 1px 2px #000000;
  }

  .inner :global(b) {
    white-space: nowrap;
    color: #ffffff;
  }

  h1 {
    margin-bottom: 0.5em;
    font-family: 'Dosis', sans-serif;
    padding: 0 0.5em 0.25em 0.5em;
    border-bottom: solid 2px #ffffff;
    font-weight: 400;
    font-style: normal;
    text-transform: none;
    letter-spacing: 0;
    color: #ffffff;
    font-size: 2em;
  }

  h1 :global(a) {
    border-bottom: 0;
    transition: none;
    color: inherit;
  }

  h1 :global(a:hover) {
    color: inherit !important;
  }

  p {
    text-transform: uppercase;
    letter-spacing: 0.325rem;
    font-weight: 400;
    font-size: 0.6em;
    padding: 0 1.25em;
    color: rgba(255, 255, 255, 0.75);
  }

  #header.alt {
    height: 20em;
    min-height: 50vh;
  }

  #header.alt h1 {
    font-size: 4em;
    padding: 0 0.5em 0.25em 0.5em;
  }

  #header.alt p {
    font-size: 0.8em;
  }

  #header.alt h1,
  #header.alt p {
    position: relative;
    opacity: 0;
    transform: translateY(20px);
    animation: riseUp 1.5s ease-out forwards;
  }

  @keyframes riseUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 736px) {
    #header {
      padding: 4em 2em 2em 2em;
    }

    #header.alt h1 {
      font-size: 2.5em;
      padding-left: 0;
      padding-right: 0;
    }

    #header.alt p {
      padding: 0;
    }

    #header.alt .inner {
      max-width: 20em;
    }
  }
</style>
